import * as React from 'react';

import EnterpriseExploreMenuItem from 'bundles/composable-page-header-enterprise/components/mobile/EnterpriseExploreMenuItem';
import ExploreEnterpriseSubmenu from 'bundles/composable-page-header-enterprise/components/mobile/ExploreEnterpriseSubmenu';
import MobileMenuConfigWrapper from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuConfigWrapper';
import GetAppMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/GetAppMenuItem';
import MobileAuthMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MobileAuthMenuItem';
import { MOBILE_MAIN_IDENTIFIER, logInButtonProps } from 'bundles/composable-page-header/constants';

const DefaultLoggedOutEnterpriseMobileMenuConfig = () => {
  return (
    <MobileMenuConfigWrapper
      subPagesMap={{
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_MENU]: <ExploreEnterpriseSubmenu />,
      }}
    >
      <EnterpriseExploreMenuItem />
      <GetAppMenuItem />
      <MobileAuthMenuItem buttons={[logInButtonProps()]} />
    </MobileMenuConfigWrapper>
  );
};

export default DefaultLoggedOutEnterpriseMobileMenuConfig;
